'use strict';

const $body = $('body');
const $searchInputHeader = $('.js-search-open');
const $searchInputModal = $('#autocomplete-input');
const $searchModal = $('.search-mobile-wrapper');
const $closeSearchModal = $('.js-search-close');

$searchInputHeader.on('click tap touch', () => {
  $body.addClass('overflow-hidden');
  $searchModal.addClass('is-open');

  $searchInputModal.blur(); // For iOS issues
  $searchInputModal.focus();
});

$closeSearchModal.on('click tap touch', (event) => {
  event.stopPropagation();

  $body.removeClass('overflow-hidden');
  $searchModal.removeClass('is-open');
});
